















import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { IQuestionnaireOption } from "../../../../../../../documaker/domain/format/objects";

@Component
export default class QuestionnaireAnswerOptionSelector extends Mixins() {
  @Prop({ default: () => [] as IQuestionnaireOption[] })
  options: IQuestionnaireOption[];

  @Prop()
  selectedOption: IQuestionnaireOption;

  $refs!: {
    table: ElTable,
  };

  toRowClassName(row: IQuestionnaireOption): string {
    return this.selectedOption === row ? "selected" : "";
  }

  @Watch("options")
  onOptionsUpdated(newValue: IQuestionnaireOption[], oldValue: IQuestionnaireOption[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  rowClick(value: IQuestionnaireOption) {}

  @Emit()
  selectionChange(value: IQuestionnaireOption[]) {}
}
